import React, { useState } from 'react'
import { Container, Dialog, DialogContent } from '@mui/material'
import { FunctionalUnitList } from './FunctionalUnitList'
import FunctionalUnitForm from '../forms/FunctionalUnitForm'
import { enqueueSnackbar } from 'notistack'
import { FunctionalUnitDTO } from '../../services/functionalUnitService'
import { useFunctionalUnit } from '../../hooks/useFunctionalUnit'

export const FunctionalUnitContainer: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingFunctionalUnit, setEditingFunctionalUnit] =
    useState<FunctionalUnitDTO | null>(null)
  const { remove } = useFunctionalUnit()

  const handleOpenModal = () => {
    setEditingFunctionalUnit(null)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleSuccess = () => {
    const message = editingFunctionalUnit
      ? 'Unité fonctionnelle modifiée avec succès'
      : 'Unité fonctionnelle enregistrée avec succès'
    enqueueSnackbar(message, {
      variant: 'success',
    })
  }

  const handleEdit = (functionalUnit: FunctionalUnitDTO) => {
    setEditingFunctionalUnit(functionalUnit)
    setIsModalOpen(true)
  }

  const handleDelete = async (id: number) => {
    try {
      await remove(id)
      enqueueSnackbar('Unité fonctionnelle supprimée avec succès', {
        variant: 'success',
      })
    } catch (error) {
      enqueueSnackbar(
        'Erreur lors de la suppression de l\'unité fonctionnelle',
        {
          variant: 'error',
        },
      )
    }
  }

  return (
    <Container
      maxWidth={false}
      sx={{
        height: '100vh',
        marginTop: '15px',
      }}
    >
      <FunctionalUnitList
        onAdd={handleOpenModal}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <Dialog
        open={isModalOpen}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
        TransitionProps={{
          onExited: () => setEditingFunctionalUnit(null),
        }}
      >
        <DialogContent>
          <FunctionalUnitForm
            onClose={handleCloseModal}
            onSuccess={handleSuccess}
            editingFunctionalUnit={editingFunctionalUnit}
          />
        </DialogContent>
      </Dialog>
    </Container>
  )
}
